/**
 * @generated SignedSource<<aaa4ee3a154ae2d1799bf4bdb9e665e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeDesignManagerModal_item$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "TradeDesignManagerModal_item";
};
export type TradeDesignManagerModal_item$key = {
  readonly " $data"?: TradeDesignManagerModal_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"TradeDesignManagerModal_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TradeDesignManagerModal_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "2dcfb2291d5e1b86f198cc4e5908b7c4";

export default node;
